const app = {
  state: {
    device: 'mobile',
    barText:'首页',
    activeBar:0
  },
  mutations: {
    setBarText(state,barText){
      state.barText = barText
    },
    setActiveBar: (state,active) => {
      state.activeBar = active
    },
  },
  actions: {

  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js